import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import PageTitle from '../ui/PageElements/PageTitle/PageTitle'
import { Alert, Divider, Empty, Form, message, Modal } from 'antd'
import style from './style.m.less'
import { BackArrow, Box, CenteredSpin, PrimaryButton } from '../ui'
// import { DropdownSelector3 } from './components'
import PageContainer from '../ui/PageElements/PageContainer/PageContainer'
import Card from '../ui/Card/Card'
import { useNavigate } from 'react-router-dom'
import { RequestTypes } from '../hooks'
import useRequest from '../hooks/useRequest'
import request from '../../services/request'
import { useAppSelector } from '../../store/hooks'
import { Calendar } from '../../assets/icons'
import { TimeRangePicker } from '../ui'
import moment from 'moment/moment'
import { DropdownSelector3 } from './components'
import { PreviewModal } from '../ui/Certificates/PreviewModal/PreviewModal'

interface Generator {
    generator_id: string
    uid_go_owner: string
    name: string
}

const RETURN_URL = '/ownership-certificates?tab=1'

export const IssueOwnershipCertificateSelfRedeemed: FC = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    const userInfo = useAppSelector((store) => store.user)
    const { data } = userInfo
    const userId = data?.uid

    const [form] = Form.useForm()
    const [disableSend, setDisableSend] = useState(true)

    const [period, setPeriod] = useState<[moment.Moment, moment.Moment] | null>()
    const [disablePeriod, setDisablePeriod] = useState(false)

    const [generatorsList, setGeneratorsList] = useState<Generator[]>([])
    const [currentGenerator, setCurrentGenerator] = useState<Generator | null>(null)
    const [generatorsError, setGeneratorError] = useState<boolean>(false)

    const { fetch: fetchGenerators } = useRequest({
        link: '/api/extension/v1/extension/ownership_certificates/self_redeemed/users/',
        method: RequestTypes.get,
    })
    const { fetch: fetchCertificateCreate } = useRequest({
        link: '/api/extension/v1/extension/ownership_certificates/self_redeemed',
        method: RequestTypes.post,
    })

    useEffect(() => {
        const isReady = !!period && !!currentGenerator

        setDisableSend(!isReady)
    }, [currentGenerator, period])

    useEffect(() => {
        if (userId) {
            getGenerators(userId)
        }
    }, [userId])

    useEffect(() => {
        if (!currentGenerator) {
            setPeriod(null)
            setDisablePeriod(true)
        } else {
            setDisablePeriod(false)
        }
    }, [currentGenerator])

    const getPayload = () => {
        return {
            user_id: userId,
            generator_id: currentGenerator?.generator_id,
            start_date: period?.[0]?.format('YYYY-MM-01'),
            end_date: period?.[1]?.format('YYYY-MM-01'),
        }
    }

    const getGenerators = async (user_id: string) => {
        fetchGenerators({
            addToLink: `${user_id}/generators`,
            onError: () => {
                setGeneratorError(true)
            },
            onSuccess: (data) => {
                setGeneratorError(false)
                setGeneratorsList(data)
            },
        })
    }

    const onFinish = async () => {
        setDisableSend(true)

        try {
            const payload = getPayload()
            fetchCertificateCreate({
                body: payload,
                showError: false,
                onSuccess: () => navigate(RETURN_URL),
                onError: (err) => message.error(err.detail),
            })
        } catch (error) {
            console.error('Ошибка при создании сертификата:', error)
        } finally {
            setDisableSend(false)
        }
    }

    return !userId ? (
        <CenteredSpin />
    ) : (
        <PageContainer className={style.container}>
            <PageTitle
                title={
                    <>
                        <BackArrow link={RETURN_URL} />
                        Выпустить Свидетельство о возникновении прав в отношении собственных
                        производственных нужд
                    </>
                }
            />
            {!generatorsError ? (
                <Card>
                    <Form
                        form={form}
                        onFinish={onFinish}
                        name="issueOwnershipCertificateSelfRedeemed"
                        layout="vertical"
                    >
                        <Form.Item
                            name="go_id"
                            className={style.dropdownWrapper}
                            label={
                                <span>
                                    {t('ownershipCertificate.certTable.GOName')}
                                    {/*
                                        <Tooltip
                                            title={t('ownershipCertificate.certForm.tooltips.user')}
                                            overlayStyle={{ maxWidth: 300 }}
                                        >
                                            <QuestionCircleOutlined
                                                style={{
                                                    marginLeft: 8,
                                                    color: 'rgba(0, 0, 0, 0.45)',
                                                }}
                                            />
                                        </Tooltip>
                                    */}
                                </span>
                            }
                            rules={[
                                {
                                    required: true,
                                    message: t('ownershipCertificate.certForm.GORequired'),
                                },
                            ]}
                        >
                            <DropdownSelector3
                                placeholder={t('ownershipCertificate.certForm.GOPlaceholder')}
                                options={generatorsList?.map((item) => ({
                                    text: item.name,
                                    label: item.name,
                                    value: item.generator_id,
                                    id: item.generator_id,
                                }))}
                                onChange={(value) =>
                                    setCurrentGenerator(
                                        generatorsList.find(
                                            (item) => item.generator_id === value,
                                        ) || null,
                                    )
                                }
                                noDefaultValue={true}
                            />
                        </Form.Item>
                        <Form.Item
                            name="period"
                            label={
                                <span>
                                    {t('ownershipCertificate.certTable.generationPeriod')}
                                    {/*
                                        <Tooltip
                                            title={t(
                                                'ownershipCertificate.certForm.tooltips.period',
                                            )}
                                            overlayStyle={{ maxWidth: 300 }}
                                        >
                                            <QuestionCircleOutlined
                                                style={{
                                                    marginLeft: 8,
                                                    color: 'rgba(0, 0, 0, 0.45)',
                                                }}
                                            />
                                        </Tooltip>
                                    */}
                                </span>
                            }
                            rules={[
                                {
                                    required: true,
                                    message: t(
                                        'ownershipCertificate.certForm.generationPeriodRequired',
                                    ),
                                },
                            ]}
                            className={style.dropdownWrapper}
                        >
                            <TimeRangePicker
                                suffixIcon={<Calendar color={'#8C8C8C'} />}
                                placeholder={['Дата начала', 'Дата окончания']}
                                value={period}
                                onChange={(value) => setPeriod(value)}
                                format={'MM.YYYY'}
                                picker={'month'}
                                minDate={moment('2024-02-01')}
                                maxDate={moment().endOf('month')}
                                disabled={disablePeriod}
                            />
                        </Form.Item>
                    </Form>
                    <Alert
                        className={style.modalAlert}
                        message={
                            <div className={style.modalAlertText}>
                                <div>{t('ownershipCertificate.certForm.tooltips.submitFirst')}</div>
                                <div>
                                    {t(
                                        'ownershipCertificate.certForm.tooltips.submitSecondSelfRedeemed',
                                    )}
                                </div>
                            </div>
                        }
                        type="warning"
                        showIcon
                    />
                    <Divider />
                    <Box direction="row" justify="flex-start" margin="32px 0px 0px 0px">
                        <PrimaryButton
                            onClick={() => navigate(RETURN_URL)}
                            value={t('ownershipCertificate.certForm.cancelButton')}
                            isCancel
                            customStyle={{ padding: '8px 16px' }}
                        />
                        <PrimaryButton
                            onClick={() => form.submit()}
                            disabled={disableSend}
                            value={t('ownershipCertificate.certForm.saveButton')}
                            customStyle={{ marginLeft: '16px', padding: '8px 16px' }}
                        />
                        <PreviewModal
                            previewUrl="/api/extension/v1/files/certificates/ownership/self_redeemed/preview"
                            setDisableSend={setDisableSend}
                            getPayload={getPayload}
                            disabled={disableSend}
                        />
                    </Box>
                </Card>
            ) : (
                <Card className={style.emptyCard}>
                    <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description={t('ownershipCertificate.certForm.emptyText')}
                    />
                </Card>
            )}
        </PageContainer>
    )
}

export default IssueOwnershipCertificateSelfRedeemed
